import * as React from 'react';
import {
  Dialog,
  DialogContent,
  Grid,
  Button,
  Typography,
  TextField,
} from '@material-ui/core';
import { useSnackbar } from 'notistack';
import type { AxiosError } from 'axios';
import axios from 'axios';

interface CourierOverrideModalProps {
  onClose: () => void;
  open: boolean;
  managerCode: string;
  setManagerCode: React.Dispatch<React.SetStateAction<string>>;
  handleManagerOverride: () => void;
}

const CourierOverrideModal: React.FC<CourierOverrideModalProps> = ({
  onClose, open, managerCode, setManagerCode, handleManagerOverride,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const handleManagerCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setManagerCode(event.target.value);
  };

  const pickupRepairCommand = (managerCodeInput: string) => {
    axios.post('/courier/verifyManager', { Barcode: managerCodeInput })
      .then(
        () => {
          handleManagerOverride();
        },
      )
      .catch((e: AxiosError) => {
        enqueueSnackbar(e?.response?.data, { persist: false, variant: 'error' });
      });
  };

  return (
    <Dialog
      onClose={onClose}
      open={open}
      fullWidth
      maxWidth="sm"
    >
      <DialogContent>
        <Grid container direction="row-reverse" spacing={2}>
          <Grid item xs={12}>
            <Typography style={{ fontSize: '1rem' }} variant="subtitle1">
              {'MISSING REPAIR(S)'}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5" style={{ color: '#587B9F', fontWeight: 700 }}>
              {'Manager code is needed due to repairs that are missing this courier round'}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography display="inline" style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: '0.875rem' }} variant="subtitle1">
              {'At the end of your courier round, you have some missing repairs that have not been resolved. A manager code is needed to end this round and acknowledge missing repairs.'}
            </Typography>
          </Grid>
          <Grid item xs={12} />
          <Grid item xs={12}>
            <TextField size="small" fullWidth label="Manager Code" variant="outlined" type="password" value={managerCode} onChange={handleManagerCodeChange} />
          </Grid>
          <Grid item xs={12} />
          <Grid item>
            <Button
              id="request-override-button"
              color="secondary"
              variant="contained"
              onClick={() => pickupRepairCommand(managerCode)}
            >
              {'REQUEST OVERRIDE'}
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default CourierOverrideModal;
